var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "s_facebook",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "22px",
    width: "12px",
    viewBox: "0 0 17 31.4",
    style: {
      enableBackground: "new 0 0 17 31.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n                                .st2{fill:#a9c5d7;}\n                            ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.4,0l-4.1,0C7.7,0,4.7,3,4.7,7.7v3.6H0.6c-0.4,0-0.6,0.3-0.6,0.6v5.2c0,0.4,0.3,0.6,0.6,0.6h4.1v13                                     c0,0.4,0.3,0.6,0.6,0.6h5.3c0.4,0,0.6-0.3,0.6-0.6v-13h4.8c0.4,0,0.6-0.3,0.6-0.6l0-5.2c0-0.2-0.1-0.3-0.2-0.5                                     c-0.1-0.1-0.3-0.2-0.5-0.2h-4.8v-3c0-1.5,0.3-2.2,2.2-2.2l2.7,0c0.4,0,0.6-0.3,0.6-0.6V0.6C17,0.3,16.7,0,16.4,0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8d8f16e8c466e6788aefd6dadcee3db2.svg";
export { ForwardRef as ReactComponent };